import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  progress: {
    display: 'flex',
    height: 12,
    borderRadius: 8,
  },

  line: {
    display: 'block',
    height: '100%',
    borderRadius: 'inherit',
  },

  lineMain: {
    flexShrink: 0,
    marginRight: theme.spacing(1),
    backgroundColor: theme.palette.primary.dark,
    minWidth: 24,
  },

  lineActive: {
    height: 'calc(100% + 4px)',
    backgroundColor: theme.palette.orange.main,
    border: `solid #191919`,
    borderWidth: 2,
    paddingTop: 0,
    marginTop: -2,
  },

  noMargin: {
    margin: 0,
  },

  lineRest: {
    flexGrow: 1,
    backgroundColor: '#303030',
    minWidth: 12,
  },
}));
